<div [kalLoading]="loading$ | async"
     kalDialogContent>

    <app-shared-mail *ngIf="!isMultiple else multipleMails"
                     [documentCodesList]="mailParameters[0].documentCodesList"
                     [documentCodesListMode]="mailParameters[0].documentCodesListMode"
                     [generatedDocumentsList]="mailParameters[0].generatedDocumentsList"
                     [formControl]="formControl"
                     [publipostageCode]="mailParameters?.[0]?.publipostageCode"
                     [viewId]="mailParameters?.[0]?.viewId">
    </app-shared-mail>

</div>

<div *ngIf="!isMultiple"
     class="gup-C-validationArea gup-O-list"
     kalDialogFooter>

    <div class="gup-O-list__item">
        <kal-button (click)="sendMail()"
                    [disabled]="formControl.invalid || (loading$ | async)"
                    id="shared_publipostage_button_sendMail"
                    kalTheme="primary">
            Envoyer l'e-Mail
        </kal-button>
    </div>

    <div class="gup-O-list__item">
        <kal-button (click)="close()"
                    id="shared_publipostage_button_close"
                    kalTheme="secondary">
            Fermer sans envoyer
        </kal-button>
    </div>

</div>

<ng-template #multipleMails>
    <app-shared-mail-container (closeContainer)="close()"
                               [mailParameters]="mailParameters">
    </app-shared-mail-container>
</ng-template>
